import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { bizApi, saveBiz } from "@/lib/bizApi";
import { MusicNotesSimple, Storefront, ArrowLeft, Eye, EyeSlash } from "@phosphor-icons/react";

export default function NegociosLogin() {
  const nav = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!phone || !password) return toast.error("Llena todos los campos");
    setLoading(true);
    try {
      const { data } = await bizApi.post("/business/login", { phone, password });
      saveBiz(data.token, data.business);
      nav("/negocios/panel");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenciales incorrectas");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col">
      <div className="max-w-md w-full mx-auto px-4 py-10 flex-1 flex flex-col justify-center">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-6 w-fit px-3 py-2 -ml-3 rounded-full hover:bg-white/5 transition-colors"
          data-testid="biz-login-back-home"
        >
          <ArrowLeft size={16} weight="bold" /> Volver al inicio
        </Link>
        <Link to="/" className="flex items-center gap-2 mb-10">
          <div className="w-10 h-10 rounded-full bg-[#FFB800] flex items-center justify-center">
            <MusicNotesSimple weight="fill" size={22} className="text-black" />
          </div>
          <span className="font-display font-bold text-2xl">Tu MusiKa <span className="text-[#B4F34A]">Negocios</span></span>
        </Link>

        <div className="flex items-center gap-2 mb-2">
          <Storefront weight="fill" size={26} className="text-[#B4F34A]" />
          <h1 className="font-display text-3xl font-bold">Bienvenido de vuelta</h1>
        </div>
        <p className="text-white/50 mb-8">Inicia sesión en tu cuenta de negocio</p>

        <form onSubmit={submit} className="space-y-4" data-testid="biz-login-form">
          <div>
            <label className="text-xs uppercase tracking-widest text-white/60 mb-2 block">Teléfono</label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Teléfono registrado"
              className="w-full px-4 py-3 rounded-xl bg-[#121212] border border-white/10 focus:border-[#B4F34A] outline-none text-white placeholder-white/30"
              data-testid="biz-login-phone"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/60 mb-2 block">Contraseña</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 pr-12 py-3 rounded-xl bg-[#121212] border border-white/10 focus:border-[#B4F34A] outline-none text-white"
                data-testid="biz-login-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(v => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 rounded-lg text-white/50 hover:text-white"
              >
                {showPassword ? <EyeSlash size={18} weight="bold" /> : <Eye size={18} weight="bold" />}
              </button>
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 rounded-full bg-[#B4F34A] hover:bg-[#A0E03A] disabled:opacity-40 text-black font-semibold active:scale-95 transition-all"
            data-testid="biz-login-submit"
          >
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
        <p className="text-center text-sm text-white/50 mt-6">
          ¿Aún no tienes cuenta?{" "}
          <Link to="/negocios" className="text-[#B4F34A] hover:underline" data-testid="biz-login-go-register">
            Regístrate aquí
          </Link>
        </p>
      </div>
    </div>
  );
}
